Customer.Users ||= {}

class Customer.Users.ExternalTicketsView extends Backbone.View
  template: JST['backbone/templates/customer/users/external_tickets']
  conversationWrapper: JST["backbone/templates/customer/users/conversation_wrapper"]
  className: 'tab-pane'
  id: 'external-tickets'

  initialize: ({profile}) ->
    @profile = profile
    @externalTicketViews = []

  render: ->
    @$el.html(@template())
    @externalTicketViews.forEach((ticketView) =>
      @$el.find('.external-tickets-list').append(@wrappedView(ticketView))
    )
    @

  wrappedView: (ticketView) ->
    ticketViewElement = ticketView.render().$el
    if ticketView.keepconTicket()
      wrapper = $(@conversationWrapper(id: ticketView.keepconTicketId()))
      wrapper.append(ticketViewElement)
    else
      ticketViewElement

  getExternalTickets: ->
    externalTicketsJson = @profile.getExternalTickets()
    externalTickets = new Customer.Ticket.SkyChile.ExternalTicketCollection(externalTicketsJson)
    externalTickets.fetchAssociatedCEMTickets().then(=>
      @externalTicketViews = []
      externalTickets.each((externalTicket) =>
        @externalTicketViews.push(
          new Customer.Ticket.SkyChile.ExternalTicketView(externalTicket: externalTicket)
        )
      )
      @render()
    )
